import Ajax from '../helpers/Ajax';

;$(function() {

	function selectMultiOption(elem) {
		let papa = elem.parents('ul').eq(0);
		let block = elem.parents('.custom-select').eq(0);
		let value = elem.attr('data-value');
		let group = elem.attr('data-group');

		if (elem.hasClass('custom-select__multi-option_selected')) {
			elem.removeClass('custom-select__multi-option_selected');

			if (papa.find('.custom-select__multi-option_selected').length == 0)
				papa.find('[data-value=""]').addClass('custom-select__option_selected');

			if (group == '')
				block.children('input[value="' + value + '"]').remove();
			else
				block.children('input[name="' + group + '[]"][value="' + value + '"]').remove();
		} else {
			elem.addClass('custom-select__multi-option_selected');

			if (papa.find('[data-value=""]').length)
				papa.find('[data-value=""]').removeClass('custom-select__option_selected');

			block.append('<input type="hidden" name="' + group + '[]" value="' + value + '">');
		}
	}

	function checkForGrouping(elem) {
		let papa = elem.parent().parent();

		if (elem.data('parent')) {
			let selectParent = true;
			let id = elem.data('parent');
			let children = papa.find('[data-parent="' + id + '"]');
			let parent = papa.find('[data-is-parent="' + id + '"]');

			for (let i = 0; i < children.length; i++) {
				if (! children.eq(i).hasClass('custom-select__multi-option_selected'))
					selectParent = false;
			}

			if (selectParent != parent.hasClass('custom-select__multi-option_selected'))
				selectMultiOption(parent);

		} else if (elem.attr('data-is-parent')) {

			let id = elem.attr('data-is-parent');
			let children = papa.find('[data-parent="' + id + '"]');

			for (let i = 0; i < children.length; i++) {
				if (children.eq(i).hasClass('custom-select__multi-option_selected') != elem.hasClass('custom-select__multi-option_selected')) {
					selectMultiOption(children.eq(i));
				}
			}
		}
	}

	$(document).on('click', '.custom-select__button', function(e) {
		e.stopPropagation();

		if ($(this).hasClass('custom-select__button_active')) {
			$('.custom-select__button_active').removeClass('custom-select__button_active');
			$('.custom-select__list_shown').removeClass('custom-select__list_shown');
		} else {
			$('.custom-select__button_active').removeClass('custom-select__button_active');
			$('.custom-select__list_shown').removeClass('custom-select__list_shown');
			$(this).toggleClass('custom-select__button_active');
			$(this).parents('.custom-select').find('.custom-select__list').toggleClass('custom-select__list_shown');
		}
	});

	$(document).on('click', '.custom-select__option', function(e) {
		e.stopPropagation();

		var customSelect = $(this).parents('.custom-select');

		if (! $(this).parents('.custom-select__wrapper_multi').length) {
			customSelect.find('.custom-select__button_active').removeClass('custom-select__button_active');
			customSelect.find('.custom-select__list_shown').removeClass('custom-select__list_shown');
		}
		customSelect.find('.custom-select__default').attr('value', $(this).attr('data-value'));
		customSelect.find('.custom-select__default').trigger('change');
		customSelect.find('.custom-select__button').attr('data-default-text', customSelect.find('.custom-select__button .custom-select__caption').html());
		customSelect.find('.custom-select__button .custom-select__caption').html($(this).html());

		$(this).parents('.custom-select__list').find('.custom-select__option_selected').removeClass('custom-select__option_selected');
		$(this).addClass('custom-select__option_selected');

		if (customSelect.find('.custom-select__multi-option').length) {
			if ($(this).data('value') == '') {
				$(this).parents('.custom-select__list_multi').eq(0).find('.custom-select__button .custom-select__caption').html($(this).parents('.custom-select__list_multi').eq(0).find('.custom-select__button').data('default'));
				$(this).parent().parent().find('.custom-select__multi-option_selected').each(function() {
					selectMultiOption($(this));
				});
				$(this).parents('.custom-select').eq(0).children('input').remove();
			} else {
				checkForGrouping($(this));
			}
		}

		if ($(this).parents('.filter').length)
			setTimeout(Ajax.filter.count, 100);
	});

	$(document).on('click', '.custom-select__multi-option', function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();

		let _ = $(this);
		let grandpapa = _.parents('.custom-select__list').eq(0);
		let papa = _.parents('ul').eq(0);
		let block = _.parents('.custom-select').eq(0);
		let value = _.data('value');
		let group = _.data('group');

		selectMultiOption(_);

		checkForGrouping(_);

		let selected = grandpapa.find('.custom-select__multi-option_selected');
		let text = block.find('.custom-select__button').data('default');

		if (selected.length == 1)
			text += ': ' + selected.html();
		else if (selected.length)
			text += ': выбрано ' + selected.length;

		block.find('.custom-select__caption').html(text);

		setTimeout(Ajax.filter.count, 100);
	});
});

;$(function() {

	var page = {};
	page.list = {};
	page.list.wrapper = $('.custom-select__list');
	page.list.close = '.custom-select__list-close';
	page.list.shown = '.custom-select__list_shown';
	page.list.dropdownButton = '.custom-select__button';

	var action = {};
	action.onDocumentClick = e => {
		if (! $('body').find(page.list.shown).length) return;

		if (! $(e.target).parents(page.list.shown).length &&
			! $(e.target).parents(page.list.dropdownButton).length &&
			! $(e.target).hasClass(page.list.dropdownButton.slice(1)[0])) {
			$(page.list.dropdownButton + '_active').trigger('click');
		}
	}

	action.list = {};
	action.list.close = {};
	action.list.close.onClick = function() {

		let wrapper = $(this).parent();
		wrapper.prev().trigger('click');

		let offsetTop = wrapper.offset().top;
		let topHeight = $('.header__top').height();

		if ($(window).scrollTop() + topHeight + 50 > offsetTop) {
			$('html, body').animate({
				scrollTop: (offsetTop - topHeight - 50)
			}, 400);
		}

	}

	// $(document).on('click', page.list.close, action.list.close.onClick );

	$(document).click( action.onDocumentClick )

});